import ContaoService from './ContaoService'
import ContaoServiceMock from './ContaoServiceMock'
// import ShopmanagerService from './ShopmanagerService'
// import ShopmanagerServiceMock from './ShopmanagerServiceMock'
import DatatransService from '@/service/DatatransService'
import { config } from '@/config'

let tmpContao = new ContaoService()
// let tmpService = new ShopmanagerService()
let tmpDatatrans = new DatatransService()

updateServiceConfig()

//TODO: currently singleton, could be upgraded to context
export const contaoService = tmpContao
// export const service = tmpService
export const datatrans = tmpDatatrans

export function updateServiceConfig() {
	tmpContao.endpoint = config.CONTAO_ENDPOINT
	// tmpService.endpoint = config.SHOPMANAGER_ENDPOINT
	tmpDatatrans.scriptUrl = config.DATATRANS_SCRIPT
	if (config.ACCUMULATOR) {
		// tmpService.accumulatorUrl = config.SHOPMANAGER_ENDPOINT + '/shop-api/accumulator'
	}
	if (config.MOCK && tmpService.mock == null) {
		tmpContao.mock = new ContaoServiceMock()
		// tmpService.mock = new ShopmanagerServiceMock()
	} else if (!config.MOCK) {
		tmpContao.mock = null
		// tmpService.mock = null
	}
	if (config.MOCK_CARTOPEN_FAILONCE) {
		// tmpService.mock.fakeFailOpenOnce = true
	}
}
